import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class UniformDailyColumnManager extends ScheduleColumnManager {
  addIntermediateColumns(columns) {
    super.addIntermediateColumns(columns);

    this.addColumn(columns, {
      alignment: 'left',
      allowEditing: false,
      allowFiltering: true,
      allowHiding: true,
      allowResizing: true,
      dataType: 'string',
      caption: 'Contract',
      dataField: 'contractDisplayName',
      visible: false,
      width: 80
    });
  }

  addTrailingColumns(columns) {
    super.addTrailingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (Hours)',
      dataField: 'energySumH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 85
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (MWh)',
      dataField: 'energySumMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 85
    });
  }

  getColumnCssClass() {
    return 'pwx-alert-overlay-none pwx-flag-none pwx-select-none pwx-state-normal pwx-highlight-none pwx-cell-standard';
  }
}